export enum CountryEnum {
  CH = 'ch',
  FR = 'fr',
}
